import React from 'react';
import Video from './Video';
import ImageMedia from './ImageMedia';

const getFileType = (src) => {
  const extension = src.split('.').pop()?.toLowerCase();

  const videoExtensions = ['mp4', 'mov', 'avi', 'mkv'];
  const imageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'webp'];

  if (videoExtensions.includes(extension || '')) {
    return 'video';
  } else if (imageExtensions.includes(extension || '')) {
    return 'image';
  }
  return 'image';
};

const Media = ({ src, title, ref, className }) => {
  const type = getFileType(src);

  return (
    type === 'video' ? (
      <Video src={src} title={title} videoRef={ref} autoPlay isMuted className={"object-cover w-full h-full"} />
    ) : (
      <ImageMedia src={src} title={title} key={ref?.current?.id} className={className} />
    )
  );
};

export default Media;
